import { Preferences } from '@capacitor/preferences';
import { StateStorage } from 'zustand/middleware';

const storage: StateStorage = {
  setItem: async (name: string, value: string): Promise<void> => {
    await Preferences.set({
      key: name,
      value: value,
    });
  },
  getItem: async (name: string): Promise<string | null> => {
    const { value } = await Preferences.get({
      key: name,
    });
    return value ? value : null;
  },
  removeItem: async (name: string): Promise<unknown> => {
    return await Preferences.remove({
      key: name,
    });
  },
};

export default storage;
